export interface AXRouteAuthorityRecord {
  readonly route: string;
  readonly authority: string;
  readonly description: string;
}

const AX_ROUTE_AUTHORITIES: readonly AXRouteAuthorityRecord[] =
Object.freeze([
  {
    route: '/',
    authority: 'AX Governor',
    description: 'Landing Page',
  },
  {
    route: '/login',
    authority: 'AX Governor',
    description: 'Login Page',
  },
  {
    route: '/signup',
    authority: 'AX Governor',
    description: 'Signup Page',
  },
  {
    route: '/membership',
    authority: 'AX Governor',
    description: 'Membership',
  },
  {
    route: '/governor-command-center',
    authority: 'AX Governor',
    description: 'Command Center',
  },
]);

export function getAXRouteAuthorityRegistry():
readonly AXRouteAuthorityRecord[] {
  return AX_ROUTE_AUTHORITIES;
}
